import React, { Component } from 'react'
import type { Track, TrackAliasValue } from 'types/track'
import type { MixedValueMap } from '@disco/utils/commonMetadata'
import styles from './index.module.css'

export default class TrackAliasTable extends Component<{
  track: Track
  currentMetadata: MixedValueMap
}> {
  _formatValue(aliasValueObj: TrackAliasValue | string, key: string): string {
    if (typeof aliasValueObj === 'string') return aliasValueObj

    if (aliasValueObj && aliasValueObj.include) {
      return aliasValueObj.value.toString()
    } else if (aliasValueObj && !aliasValueObj.include) {
      return '-'
    } else {
      const metadataValueObj = this.props.currentMetadata[key]

      if (metadataValueObj && metadataValueObj.value) {
        return metadataValueObj.value
      } else {
        return '-'
      }
    }
  }

  render(): React.ReactElement<'table'> {
    const aliases = this.props.track.aliases || []
    return (
      <table className={styles.trackAliasTable}>
        <thead>
          <tr>
            <th className={styles.trackAliasTablePlaylistHead}>Playlist</th>
            <th className={styles.trackAliasTableHead}>Title</th>
            <th className={styles.trackAliasTableHead}>Artist</th>
            <th className={styles.trackAliasTableHead}>Album</th>
          </tr>
        </thead>
        <tbody>
          {aliases.map((alias, idx) => (
            <tr key={idx}>
              <td className={styles.trackAliasTableCell}>
                {alias['Playlist name'] ? (
                  <span>{alias['Playlist name']}</span>
                ) : (
                  <span>-</span>
                )}
              </td>
              <td className={styles.trackAliasTableCell}>
                {this._formatValue(alias.Title, 'Title')}
              </td>
              <td className={styles.trackAliasTableCell}>
                {this._formatValue(alias.Artist, 'Artist')}
              </td>
              <td className={styles.trackAliasTableCell}>
                {this._formatValue(alias.Album, 'Album')}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )
  }
}
